var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73107 6.95043C2.39567 4.17301 4.60794 2.00437 7.44124 1.35288C9.48741 0.882375 11.6169 0.882374 13.6631 1.35288C16.4964 2.00437 18.7086 4.17301 19.3732 6.95043C19.8532 8.95626 19.8532 11.0437 19.3732 13.0496C18.7086 15.827 16.4964 17.9956 13.6631 18.6471C11.6169 19.1176 9.48741 19.1176 7.44124 18.6471C4.60794 17.9956 2.39567 15.827 1.73107 13.0496C1.2511 11.0437 1.2511 8.95626 1.73107 6.95043Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5527 13.5V9.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0715 7C11.0715 7.2668 10.848 7.5 10.5514 7.5C10.2547 7.5 10.0312 7.2668 10.0312 7C10.0312 6.7332 10.2547 6.5 10.5514 6.5C10.848 6.5 11.0715 6.7332 11.0715 7Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.d4bd6460321f834edb52500c8c7a7ad0.svg";
export { ForwardRef as ReactComponent };